import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const PT_LINK = "https://youfit.planway.com/";
const BT_LINK = "https://youfit.planway.com/";

export default function Contact() {
  const { t } = useLang();
  return (
    <div className="bg-[var(--bg)]" data-testid="contact-page">
      <section className="pt-28 md:pt-32 pb-20 md:pb-28">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <p className="overline mb-4">{t("contact.overline")}</p>
          <h1 className="font-serif font-light text-5xl sm:text-6xl text-[color:var(--ink)] tracking-tight leading-[1.05]">
            {t("contact.title.a")} <em className="text-[color:var(--accent)] not-italic">{t("contact.title.b")}</em>
          </h1>
          <p className="mt-6 text-[color:var(--ink-2)] max-w-xl mx-auto leading-relaxed text-lg">
            {t("contact.lead")}
          </p>

          {/* Direct contact buttons */}
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <a href="mailto:Sopfie_soendergaard@hotmail.com" className="btn-primary" data-testid="contact-email">
              <Mail size={16} strokeWidth={1.5} /> Sopfie_soendergaard@hotmail.com
            </a>
            <a href="tel:+4551490771" className="btn-ghost" data-testid="contact-phone">
              <Phone size={16} strokeWidth={1.5} /> 51 49 07 71
            </a>
          </div>

          {/* Locations */}
          <div className="mt-14 grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto text-left">
            <div className="card-soft p-7" data-testid="contact-location-pt">
              <div className="flex items-start gap-3">
                <MapPin size={18} strokeWidth={1.4} className="text-[color:var(--accent)] mt-1 shrink-0" />
                <div>
                  <p className="overline">{t("contact.loc.pt.label")}</p>
                  <p className="mt-2 font-serif text-2xl text-[color:var(--ink)] leading-tight">
                    {t("contact.loc.pt.name")}
                  </p>
                  <p className="mt-3 text-sm text-[color:var(--ink-3)]">
                    {t("contact.loc.pt.body")}
                  </p>
                </div>
              </div>
            </div>
            <div className="card-soft p-7" data-testid="contact-location-bt">
              <div className="flex items-start gap-3">
                <MapPin size={18} strokeWidth={1.4} className="text-[color:var(--accent)] mt-1 shrink-0" />
                <div>
                  <p className="overline">{t("contact.loc.bt.label")}</p>
                  <p className="mt-2 font-serif text-2xl text-[color:var(--ink)] leading-tight">
                    {t("contact.loc.bt.name")}
                  </p>
                  <p className="text-[color:var(--ink-2)]">{t("contact.loc.bt.city")}</p>
                  <p className="mt-3 text-sm text-[color:var(--ink-3)]">
                    {t("contact.loc.bt.body")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Booking shortcuts */}
          <div className="mt-12 grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            <a href={PT_LINK} target="_blank" rel="noreferrer" className="card-soft p-6 text-left group" data-testid="contact-book-pt">
              <p className="overline">{t("footer.pt")}</p>
              <p className="mt-2 font-serif text-2xl text-[color:var(--ink)] group-hover:text-[color:var(--accent)] transition-colors inline-flex items-center gap-2">
                {t("common.book_first")} <ArrowUpRight size={16} strokeWidth={1.6} />
              </p>
            </a>
            <a href={BT_LINK} target="_blank" rel="noreferrer" className="card-soft p-6 text-left group" data-testid="contact-book-bt">
              <p className="overline">{t("footer.bt")}</p>
              <p className="mt-2 font-serif text-2xl text-[color:var(--ink)] group-hover:text-[color:var(--accent)] transition-colors inline-flex items-center gap-2">
                {t("common.book_first")} <ArrowUpRight size={16} strokeWidth={1.6} />
              </p>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
